import React, { lazy, Suspense, useEffect, useState } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { MetaPixel } from './components/MetaPixel';
const DeferredLanding = lazy(() => import('./components/DeferredLanding').then(({
  DeferredLanding: Component
}) => ({
  default: Component
})));
export function App() {
  const [loadDeferredContent, setLoadDeferredContent] = useState(false);
  useEffect(() => {
    document.documentElement.lang = 'pl';
    document.title = 'Pracownia Małego Wynalazcy | 120 projektów STEM do zbudowania w domu';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Biblioteka projektów STEM do wydrukowania dla ciekawskich dzieci w wieku 5–12 lat.');
    const timer = window.setTimeout(() => setLoadDeferredContent(true), 900);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-background text-foreground" data-id="element-0" data-mp="3rdkgu4lyihna">
      <MetaPixel data-id="element-1" data-mp="5opiv1o0k3w" />
      <StickyHeader data-id="element-2" data-mp="682dxcgkib2" />
      <main data-id="element-3" data-mp="5gel8p3rovc">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="56l3b4umzkw" />
        <Hero data-id="element-5" data-mp="2zlv66six0xu0" />
        <TrustBar data-id="element-6" data-mp="2zm4v0cs84yy4" />
        {loadDeferredContent && <Suspense fallback={<div className="h-10 bg-background" aria-hidden="true" data-id="element-8" data-mp="33m5ck6amdq9e" />} data-id="element-7" data-mp="33movnqc0akp0">
            <DeferredLanding data-id="element-9" data-mp="33oi152avuyvf" />
          </Suspense>}
      </main>
    </div>;
}